module.exports = __webpack_public_path__ + "img/date-signed.96c6a6d4.svg";